const STORAGE_KEY = 'compare_products';
const MAX_COMPARE = 3;

// Reserved data attributes that are not product fields
const RESERVED_ATTRIBUTES = [
  'productId',
  'handle',
  'title',
  'image',
  'price',
  'compare',
  'vendorLogo'
];

/******************************** STATE*******************************/
let compareList = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

/******************************** DOM READY*******************************/
document.addEventListener('DOMContentLoaded', () => {
  bindCheckboxEvents();
  syncCheckboxes();
  renderDrawer();
  bindGlobalEvents();
  updateCompareCount();
  bindDrawerToggle(); 
});

function bindDrawerToggle() {
  const drawer = document.getElementById('compare-drawer');
  if (!drawer) return;

  const toggleHeader = drawer.querySelector('.compare-toggle-header');

  if (!toggleHeader) return;

  // Use pointerdown → better for iOS
  toggleHeader.addEventListener('pointerdown', (e) => {
    e.preventDefault();

    drawer.classList.toggle('active-inner');
  });
}


/******************************** CHECKBOX EVENTS*******************************/
function bindCheckboxEvents() {
  document.body.addEventListener('change', function (e) {
    const checkbox = e.target.closest('.js-compare-toggle');
    if (!checkbox) return;
    handleCheckboxChange(checkbox);
  });
}

/**
 * Dynamically extract all data attributes from checkbox
 */
function extractProductData(checkbox) {
  const product = {
    id: checkbox.dataset.productId,
    handle: checkbox.dataset.handle,
    title: checkbox.dataset.title,
    image: checkbox.dataset.image,
    price: checkbox.dataset.price,      
    compare: checkbox.dataset.compare,
    vendor_logo: checkbox.dataset.vendorLogo,
    varId: checkbox.dataset.varId
  };

  // Dynamically extract all other data attributes (custom fields)
  for (let key in checkbox.dataset) {
    const camelKey = key;
    
    // Skip reserved attributes
    if (RESERVED_ATTRIBUTES.includes(camelKey)) {
      continue;
    }
    
    // Convert camelCase to snake_case for storage
    const snakeKey = camelKey.replace(/([A-Z])/g, '_$1').toLowerCase();
    product[snakeKey] = checkbox.dataset[key];
  }

  return product;
}

function handleCheckboxChange(checkbox) {
  const product = extractProductData(checkbox);

  if (checkbox.checked) {
    if (compareList.length >= MAX_COMPARE) {
      checkbox.checked = false;
      return;
    }

    if (!compareList.find(p => p.id == product.id)) {
      compareList.push(product);
    }
  } else {
    compareList = compareList.filter(p => p.id != product.id);
  }

  persist();
  syncCheckboxes();
  renderDrawer();
  updateCompareCount();
}


/******************************* * SYNC CHECKBOXES *******************************/
function syncCheckboxes() {
  document.querySelectorAll('.js-compare-toggle').forEach(cb => {
    const isSelected = compareList.some(p => p.id == cb.dataset.productId);
    cb.checked = isSelected;

    const label = cb.closest('label');
    if (!isSelected && compareList.length >= MAX_COMPARE) {
      cb.disabled = true;
      label?.classList.add('disabled');
    } else {
      cb.disabled = false;
      label?.classList.remove('disabled');
    }
  });
}

// const observer = new MutationObserver(() => {
//   syncCheckboxes();
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });
if (!window.compareMutationObserver) {
  let syncScheduled = false;

  window.compareMutationObserver = new MutationObserver((mutations) => {
    // Only resync when product cards carrying a compare checkbox are actually
    // added to the DOM (e.g. AJAX pagination / filtering). Reacting to every
    // mutation would run syncCheckboxes() continuously and reset a checkbox the
    // user just ticked before it can be added to compareList.
    const compareBoxAdded = mutations.some((m) =>
      Array.from(m.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (node.matches?.('.js-compare-toggle') || node.querySelector?.('.js-compare-toggle'))
      )
    );

    if (!compareBoxAdded || syncScheduled) return;

    syncScheduled = true;
    requestAnimationFrame(() => {
      syncScheduled = false;
      syncCheckboxes();
    });
  });

  window.compareMutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}



/******************************* * DRAWER RENDER*******************************/
function renderDrawer() {
  const drawer = document.getElementById('compare-drawer');
  if (!drawer) return;

  const itemsWrap = drawer.querySelector('.compare-items');
  const hint = drawer.querySelector('.compare-hint');
  const compareBtn = drawer.querySelector('#compare-btn');
  const resetBtn = drawer.querySelector('#reset-compare');
  const toggle_header = drawer.querySelector('.compare-toggle-header');
  const drawer_inner = drawer.querySelector('.compare-drawer-inner-wrap');
  const comaprecount = drawer.querySelector('.compare-toggle-header span');

  
  
  itemsWrap.innerHTML = '';

  if (compareList.length === 0) {
    drawer.classList.add('hidden');
    drawer.classList.remove('active-drawer');
    return;
  }

  drawer.classList.remove('hidden');
  drawer.classList.add('active-drawer');
   
  // Update hint text
  if (hint) {
    hint.textContent = `Select up to ${MAX_COMPARE} products to compare (${compareList.length} selected)`;
  }

  // Update compare button text
  if (compareBtn) {
    compareBtn.textContent = `Compare (${compareList.length})`;
    comaprecount.textContent = `${compareList.length}`;
    compareBtn.disabled = compareList.length < 2;
  }
    compareList.forEach(product => {
    const itemDiv = document.createElement('div');
    itemDiv.className = 'compare-item';

   const priceHtml = product.price || '—';

    itemDiv.innerHTML = `
      <div class="compare-item-content">
        <button class="remove-compare"
          data-id="${product.id}"
          aria-label="Remove ${product.title} from comparison">✕</button>

        <img src="${product.image}"
          alt="${product.title}"
          class="compare-item-image">

        <div class="compare-item-info">
          <h6 class="compare-item-title">${product.title}</h6>
          <p class="compare-item-price">${priceHtml}</p>
        </div>
      </div>
    `;

    itemsWrap.appendChild(itemDiv);
  });


  const emptySlots = MAX_COMPARE - compareList.length;

  for (let i = 0; i < emptySlots; i++) {
    const emptyDiv = document.createElement('div');
    emptyDiv.className = 'compare-item compare-empty';
    emptyDiv.innerHTML = `
      <div class="compare-empty-box">
        Add product to compare
      </div>
    `;
    itemsWrap.appendChild(emptyDiv);
  }


  // Add remove event listeners
  itemsWrap.querySelectorAll('.remove-compare').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      removeCompare(btn.dataset.id);
    });
  });
}

/******************************** REMOVE SINGLE PRODUCT*******************************/
function removeCompare(id) {
  const product = compareList.find(p => p.id == id);

  compareList = compareList.filter(p => p.id != id);
  persist();
  syncCheckboxes();
  renderDrawer();
  updateCompareCount();
  
  if (product) {
  }
}

/******************************* * COMPARE BUTTON - OPEN MODAL *******************************/
async function openCompareModal() {
  if (compareList.length < 2) {
    return;
  }

  try {
    // Show loading state
    const modal = document.getElementById('compare-modal');
    const tableContainer = document.getElementById('compare-table');
    
    if (modal) {
      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }
    
    if (tableContainer) {
      tableContainer.innerHTML = `
        <div class="compare-loading">
          <div class="spinner"></div>
          <p>Loading comparison data...</p>
        </div>
      `;
    }

    const products = await fetchCompareProducts();
    renderCompareTable(products);

  
    if (typeof Shopify !== 'undefined' && Shopify.analytics) {
      Shopify.analytics.publish('comparison_viewed', {
        products: compareList.map(p => ({ id: p.id, handle: p.handle }))
      });
    }
  } catch (error) {
    console.error('Error loading compare data:', error);
    document.getElementById('compare-modal')?.classList.add('hidden');
    document.body.style.overflow = '';
  }
}

/******************************** FETCH PRODUCT DATA*******************************/

async function fetchCompareProducts() {
  const promises = compareList.map(item => {
    return fetch(`/products/${item.handle}.js`)
      .then(res => res.json())
      .then(data => {
        // Start with the fetched product data
        const productData = { ...data };
        
        // Add all stored item properties (including dynamic fields)
        for (let key in item) {
          productData[key] = item[key];
        }
        
        return productData;
      });
  });

  return Promise.all(promises);
}


/******************************** RENDER COMPARISON TABLE*******************************/
/**
 * Extract dynamic fields from the first checkbox found
 * This builds the comparison table structure based on actual data attributes
 */
function getComparisonFields() {
  const firstCheckbox = document.querySelector('.js-compare-toggle');
  if (!firstCheckbox) return [];

  const fields = [];
  
  for (let key in firstCheckbox.dataset) {
    // Skip reserved attributes
    if (RESERVED_ATTRIBUTES.includes(key)) {
      continue;
    }
    
    // Convert camelCase to snake_case
    const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
    
    // Convert snake_case to Title Case for label
    const label = snakeKey
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    
    fields.push({
      label: label,
      key: snakeKey
    });
  }
  
  return fields;
}

function renderCompareTable(products) {
  const tableContainer = document.getElementById('compare-table');
  if (!tableContainer) return;

  // Dynamically get fields from checkbox data attributes
  const fields = getComparisonFields();

  let html = `
    <div class="compare-modal-header">
      <h5>Product Comparison</h5>
      <button class="close-compare" aria-label="Close comparison">✕</button>
    </div>
    <div class="compare-table-wrapper"><div class="compare-table-inner">
      <table class="compare-table">
        <thead>
          <tr>
  `;
  // Add product headers
 products.forEach((product, index) => {
  // console.log(product,"product");
  const originalProduct = compareList.find(p => p.id == product.id);
  const price = product.price;
  const compareAtPrice = product.compare;

  // Mirror PDP buy-buttons logic: the /products/{handle}.js payload sets
  // variant.available to false when inventory is 0 and policy is "deny"
  const variant = (product.variants || []).find(v => String(v.id) === String(product.varId)) || (product.variants || [])[0];
  const canAddToCart = variant ? variant.available : false;


  html += `
    <th class="product-col" data-product-id="${product.id}">
      <div class="product-header">
      
        <button class="remove-compare-modal" data-id="${product.id}" aria-label="Remove from comparison">✕</button>

        <div class="product-image">
          <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
        </div>

        ${product.vendor_logo
          ? `<div class="compare-vendor-logo">
              <img src="${product.vendor_logo}" alt="" loading="lazy">
            </div>`
          : ''
        }

        <h6 class="product-title"><a href="/products/${product.handle}">${product.title}</a></h6>

        <product-price
          class="product-card-price"
          data-product-id="${product.id}"
          style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin: 0;"
        >
          <span class="price" style="font-weight:600;">
            ${price || '—'}
          </span>

          ${
            compareAtPrice && compareAtPrice !== price
              ? `<s class="compare-at-price">${compareAtPrice}</s>`
              : ''
          }


        </product-price>

        ${canAddToCart
          ? `<button class="btn-add-to-cart button button-full" data-variant-id="${variant.id}">
          Add to Cart
        </button>`
          : `<button class="btn-add-to-cart button button-full" disabled>
          Out of stock
        </button>`}
      </div>
    </th>
  `;
});


  html += `</tr></thead><tbody>`;

  //   fields.forEach(field => {

  //   let rowHtml = '';
  //   let allNA = true;   

  //   products.forEach(product => {
  //     let value = product[field.key];

  //     if (!value || value === '' || value === 'N/A') {
  //       value = 'N/A';
  //     } else {
  //       allNA = false;   
  //     }

  //     if (field.formatter && value !== 'N/A') {
  //       value = field.formatter(value);
  //     }

  //     rowHtml += `
  //       <td class="feature-value">
  //         <div>
  //           <span>${field.label}</span> ${value}
  //         </div>
  //       </td>
  //     `;
  //   });

  //   // ✅ Only render row if NOT all N/A
  //   if (!allNA) {
  //     html += `<tr>${rowHtml}</tr>`;
  //   }

  // });

  fields.forEach(field => {

    if (field.key === 'var_id') return;

    let rowHtml = '';
    let allNA = true;

    products.forEach(product => {
      let value = product[field.key];

      if (!value || value === '' || value === 'N/A') {
        value = 'N/A';
      } else {
        allNA = false;
      }

      rowHtml += `
        <td class="feature-value">
          <div>
            <span>${field.label}</span> ${value}
          </div>
        </td>
      `;
    });

    if (!allNA) {
      html += `<tr>${rowHtml}</tr>`;
    }

  });


  html += `</tbody></table></div></div>`;

  tableContainer.innerHTML = html;

  requestAnimationFrame(() => {
    equalizeProductHeaderHeight();
  });
  // Add event listeners
  bindModalEvents();
}


/*******************************
 * HELPER FUNCTIONS
 *******************************/
function getNestedValue(obj, path) {
  return path.split('.').reduce((current, key) => {
    return current ? current[key] : undefined;
  }, obj);
}

function formatPrice(price) {
  if (typeof price === 'number') {
    return `$${(price / 100).toFixed(2)}`;
  }
  return price || '$0.00';
}


function updateCompareCount() {
  // Update any compare count indicators
  const countIndicators = document.querySelectorAll('.compare-count');
  countIndicators.forEach(indicator => {
    indicator.textContent = compareList.length;
  });
}

/******************************** MODAL EVENT BINDING*******************************/
function bindModalEvents() {
  document.querySelectorAll('.remove-compare-modal').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      removeCompare(this.dataset.id);
      document.getElementById('compare-modal').classList.add('hidden');
      document.body.style.overflow = '';
    });
  });
  document.querySelectorAll('.btn-add-to-cart').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (variantId) {
        addToCart(variantId);
      }
    });
  });

  document.querySelector('.close-compare')?.addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('compare-modal').classList.add('hidden');
    document.body.style.overflow = '';
  });
}

/*******************************
 * ADD TO CART FUNCTION
 *******************************/
function addToCart(variantId) {
  if (!variantId) return;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1
      }]
    })
  })
  .then(response => response.json())
  .then(async data => {
    // Optional theme cart info update
    if (typeof Shopify !== 'undefined') {
      Shopify.updateCartInfo && Shopify.updateCartInfo();
    }

    // ✅ Refresh + open cart drawer
    await refreshCartDrawer();
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  });
}


async function refreshCartDrawer() {
  const currentTime = Date.now();
  const cartDrawer = document.querySelector('cart-drawer-component');

  const { CartUpdateEvent } = await import('@theme/events');

  const res = await fetch(`/cart.js?${currentTime}`);
  const cart = await res.json();

  const event = new CartUpdateEvent(cart, 'manual-trigger', {
    itemCount: cart.item_count,
    source: 'custom-add-to-cart',
    sections: {},
    carttotal: cart.total_price
  });

  document.dispatchEvent(event);

  requestAnimationFrame(() => {
    cartDrawer?.open?.();
  });
}

/******************************** GLOBAL EVENTS*******************************/
function bindGlobalEvents() {
  document.getElementById('compare-btn')?.addEventListener('click', function(e) {
    e.preventDefault();
    openCompareModal();
  });

  document.getElementById('reset-compare')?.addEventListener('click', function(e) {
    e.preventDefault();
    if (compareList.length > 0 ) {
      compareList = [];
      persist();
      syncCheckboxes();
      renderDrawer();
      updateCompareCount();
    }
     const drawer = document.getElementById('compare-drawer');
      drawer?.classList.remove('active-inner');
  });

  document.addEventListener('click', function(e) {
    const modal = document.getElementById('compare-modal');
    if (modal && !modal.classList.contains('hidden') && e.target === modal) {
      modal.classList.add('hidden');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const modal = document.getElementById('compare-modal');
      if (modal && !modal.classList.contains('hidden')) {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
      }
    }
  });
}

/*******************************
 * PERSIST TO LOCAL STORAGE
 *******************************/
function persist() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(compareList));
}

function equalizeProductHeaderHeight() {
  const headers = document.querySelectorAll('.product-header');
  if (!headers.length) return;

  let maxHeight = 0;

  headers.forEach(header => {
    header.style.height = 'auto';
  });

  headers.forEach(header => {
    const height = header.scrollHeight;
    if (height > maxHeight) maxHeight = height;
  });

  headers.forEach(header => {
    header.style.height = maxHeight + 'px';
  });
}



window.addEventListener('resize', () => {
  const modal = document.getElementById('compare-modal');
  if (modal && !modal.classList.contains('hidden')) {
    equalizeProductHeaderHeight();
  }
});


window.addEventListener('load', equalizeProductHeaderHeight);
window.addEventListener('resize', equalizeProductHeaderHeight);